<script setup>

import {ref, onMounted} from 'vue'

const sourceContainerId = ref(null);
const localWidgetContainers = ref([]);

const props = defineProps({

  width: {type: Number, default: 500},
  height: {type: Number, default: 300},

  widgetContainers: {
    type: Array,
    default: []
  },

  display: {
    type: String,
    default: '',
    validator(value) {
      return ['block', 'flex'].includes(value)
    }
  },

  modelValue: {}
})

// Create reference to local, to enable direct changes to widgetContainers prop
onMounted(() => {
  if (props.widgetContainers) localWidgetContainers.value = props.widgetContainers;
})

function handleDragStart(e, sourceContainerData, sourceContainerIndex) {
  sourceContainerId.value = sourceContainerIndex;
  sourceContainerData.start = true;
  sourceContainerData.end = false;
};

function handleDragEnd(destinationContainerData) {
  destinationContainerData.start = false;
  destinationContainerData.end = true;
};

function handleDragEnter(containerData) {
  containerData.over = true;
};

function handleDragover(e) {
  e.preventDefault();
  return false;
};

function handleDragLeave(sourceContainerData) {
  sourceContainerData.over = false;
};

function handleDrop(e, destinationContainerData, containerIndex) {
  e.stopPropagation();
  destinationContainerData.over = false;
  localWidgetContainers.value[sourceContainerId.value].start = false;

  if (sourceContainerId.value !== containerIndex) {
    localWidgetContainers.value.splice(containerIndex, 1, localWidgetContainers.value[sourceContainerId.value])
    localWidgetContainers.value.splice(sourceContainerId.value, 1, destinationContainerData)
  }
};

function setCssStyles(containerData) {
  let cssStyles = ''

  if (containerData.start) cssStyles += 'dragStartOpacity '
  if (containerData.end) cssStyles += 'dragEndOpacity '
  if (containerData.over) cssStyles += 'over '

  return cssStyles
};
</script>

<template>
  <div class="cmp-widget-container_widget-wrapper" :style="{display: display}">
    <div v-for="(item, index) in localWidgetContainers">
      <div class="cmp-widget-container_widget-body">
        <div
            draggable="true"
            :class="setCssStyles(item)"
            @dragstart="handleDragStart($event, item, index)"
            @dragenter="handleDragEnter(item)"
            @dragover="handleDragover($event)"
            @dragleave="handleDragLeave(item)"
            @drop="handleDrop($event, item, index)"
            @dragend="handleDragEnd(item)">
          <div class="cmp-widget-container_drag-area"></div>
        </div>
        <slot :name="item.name"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.dragStartOpacity {
  /*opacity: 0.6;*/
}

.dragEndOpacity {
  opacity: 1;
}

.over {

}

.cmp-widget-container {

  &_widget-wrapper {
    position: relative;
    gap: 20px;
    flex-wrap: wrap;
    padding:10px;
  }

  &_drag-area {
    position: absolute;
    z-index: 9999;
    width: 200px;
    cursor: move;
    height: 40px;
  }

}


</style>
